import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import * as moduleState from './state'
import store from 'src/store'
import * as moduleSelectors from './selectors'
import { actions as moduleActions } from './actions'
import moduleSagas from './sagas'
import { builderSagaCommunications } from 'src/helpers/redux'
import { ITeamMemberPresence, IUserLocation } from 'src/services/auth/users'

export const presenceSlice = createSlice({
  name: moduleState.PREFIX,
  initialState: moduleState.initialState,
  reducers: {
    setTeam(state, action: PayloadAction<ITeamMemberPresence[]>) {
      const team: moduleState.IStateData['team'] = {}

      action.payload.forEach((member) => {
        // a realtime event may have outrun the snapshot
        const known = state.data.team[member.id]
        team[member.id] = known && known.rev > member.rev ? known : member
      })

      state.data.team = team
      state.data.isTeamLoaded = true
    },
    applyStatusUpdates(state, action: PayloadAction<ITeamMemberPresence[]>) {
      action.payload.forEach((member) => {
        const known = state.data.team[member.id]

        // broadcasts are not ordered: `rev` tells which one is newer
        if (known && known.rev >= member.rev) return

        if (member.status === 'offline') {
          delete state.data.team[member.id]

          return
        }

        state.data.team[member.id] = { ...known, ...member }
      })
    },
    applyLocationUpdates(
      state,
      action: PayloadAction<
        { id: number; currentLocation: IUserLocation | null; rev: number }[]
      >
    ) {
      action.payload.forEach((update) => {
        const known = state.data.team[update.id]
        if (!known || known.rev >= update.rev) return

        known.currentLocation = update.currentLocation
        known.rev = update.rev
      })
    },
  },
  extraReducers: (builder) => {
    builderSagaCommunications<moduleState.IState>(builder, moduleActions)
  },
})

export const reducers = { [moduleState.PREFIX]: presenceSlice.reducer }
export const selectors = moduleSelectors
export const setters = presenceSlice.actions
export const actions = moduleActions
export const sagas = moduleSagas

export const injectStore = () => {
  store.injectReducer?.(moduleState.PREFIX, presenceSlice.reducer)
  store.injectSaga?.(moduleState.PREFIX, sagas)
}
